import cloneDeep from "lodash.clonedeep";
import {hasOwn} from "~/utils";

let uuid = 0
export class BaseWidgetModel {
    constructor(options) {
      if (options) {
        Object.assign(this, options)
      }
      this.__siteId = () => {
       return 'site-widget-' + (++uuid) + (Date.now() * parseInt(Math.random() * 100))
      }
      const __getId = () => {
        return options?.id || this.__siteId()
      }
      this.name = 'BaseWidgetModel'
      this.__sortIndex = 0
      this.id = __getId()
      this.value = options?.value || undefined
      this.name = options?.name || this.constructor.name
      this.visible = typeof options === 'object' ? (options.visible === undefined ? true : options.visible) : true
      this.titleStroke = hasOwn(options, 'titleStroke', '', '')
      this.subTitleStroke = hasOwn(options, 'subTitleStroke', '', '')
      /*
      *  获取展示信息
      * */
      this.getMenuInfo = () => {
        return {
          id: this.id,
          title: 'title',
          model: TitleWidgetModel,
          icon: 'icon',
          draggable: true,
        }
      }
    }

    langChange(langKey, isAdd) {
      //
    }

    clone() {
      const newModel = cloneDeep(this)
      newModel.id = this.__siteId()
      return new this.constructor(newModel)
    }
  }

  export class TitleWidgetModel extends BaseWidgetModel {
    constructor(options) {
      super(options);
      this.name = 'TitleWidgetModel'

      this.title = options?.title || 'title'
      this.getMenuInfo = () => {
        return {
          id: this.id,
          title: 'title',
          model: TitleWidgetModel,
          icon: '',
          draggable: true,
        }
      }
    }
  }
